import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataSharedService {
  private _cartId: string = '';

  get cartId(): string {
    return this._cartId;
  }
  
  set cartId(val: string) {
    this._cartId = val;
  }
}
